import { lazy } from 'react';

import { Location } from '@core/Router/locations';

import { PLAN_CONDITIONS_ROUTE } from './planConditionsRoute';
import { PLAN_LIST_ROUTE, PLAN_ROUTE } from './planRoute';

const PlanListPage = lazy(() =>
    import(/* webpackChunkName: "plan" */ '@plan/ui/PlanListPage/PlanListPage').then(m => ({
        default: m.PlanListPage,
    })),
);
const PlanPageContainer = lazy(() =>
    import(/* webpackChunkName: "plan" */ '@plan/ui/PlanPage').then(m => ({ default: m.PlanPage })),
);
const PlanConditionsPage = lazy(() =>
    import(/* webpackChunkName: "plan" */ '@plan/ui/PlanConditionsPage').then(m => ({ default: m.PlanConditionsPage })),
);
const PlanSubscriptionsPageContainer = lazy(() =>
    import(/* webpackChunkName: "plan" */ '@modules/plan/ui/PlanSubscriptionsPage/PlanSubscriptionsPage').then(m => ({
        default: m.PlanSubscriptionsPage,
    })),
);

export const planLocations: Location[] = [
    {
        url: PLAN_LIST_ROUTE.$path(),
        Component: PlanListPage,
    },
    {
        url: PLAN_ROUTE.$path(),
        Component: PlanPageContainer,
    },
    {
        url: PLAN_CONDITIONS_ROUTE.$path(),
        Component: PlanConditionsPage,
    },
    {
        url: '/plan/:planId/subscriptions',
        Component: PlanSubscriptionsPageContainer,
    },
];
